//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    to: {
      type: String,
      default: '/'
    },
    isButton: {
      type: Boolean,
      default: false
    }
  }
}
